<app-hero
	[title]="'hero.live' | translate"
	[subtitle]=""
	imageDesktop="assets/hero/live-hero-3840x400.jpg"
	imageMobile="assets/hero/live-hero-768x180.jpg"
></app-hero>
<div class="container-xxl mh-500 mt-3">
	<div class="stickyTop bg-lightgray gray-shadow py-2 py-lg-3">
		<aside>
			@if (serverTime) {
				<clock [referenceTime]="serverTime" />
			}

			@if (!(observedAuctions?.length || leasysObservedAuctions?.length)) {
				<div class="mt-4">
					<a
						routerLink="/private"
						class="text-uppercase text-basecolor"
					>
						<span class="simple-arrow simple-arrow-left d-inline-block align-middle"></span>
						<span>{{ "auction.details.allAuctions" | translate }}</span></a
					>
				</div>
			}
		</aside>
	</div>

	@if (leasysObservedAuctions && observedAuctions) {
		<!-- they are initialized together -->
		@for (ob of leasysObservedAuctions; track ob) {
			<div class="mt-3">
				<app-live-item
					[observedAuctionDTO]="ob"
					[reconnectEmitter]="reconnectEmitter"
					(trimAuction)="trimAuction(leasysObservedAuctions, ob)"
				></app-live-item>
			</div>
		}
		@for (ob of observedAuctions; track ob) {
			<div class="mt-3">
				<app-live-item
					[observedAuctionDTO]="ob"
					[reconnectEmitter]="reconnectEmitter"
					(trimAuction)="trimAuction(observedAuctions, ob)"
				></app-live-item>
			</div>
		}
		@if (leasysObservedAuctions.length + observedAuctions.length === 0) {
			<div class="py-5 text-center">
				<span class="text-blue text-xl"> {{ "auction.live.noObservedFound" | translate }}</span>
			</div>
		}

		<section class="auction-legend">
			<ul class="p-0">
				<li class="legend-green d-inline-block">
					<strong class="lh-lg">
						<span class="align-middle">{{ "auction.live.migliorOff" | translate }}</span>
					</strong>
				</li>
				<li class="legend-red d-lg-inline-block ms-lg-4">
					<strong class="lh-lg">
						<span class="align-middle">{{ "auction.live.offertaSup" | translate }}</span>
					</strong>
				</li>
				<li class="legend-yellow d-lg-inline-block ms-lg-4">
					<strong class="lh-lg">
						<span class="align-middle">{{ "auction.live.riservaNonRag" | translate }}</span>
					</strong>
				</li>
			</ul>
			<p>
				{{ "auction.live.noOffers" | translate }}<br />
				{{ "auction.live.impegnoAcquisto" | translate }}
			</p>
		</section>
	} @else {
		<div class="pt-5 text-center">
			<span class="text-blue text-xl"> {{ "auction.live.retrievingObserved" | translate }}</span>
		</div>
	}
</div>

<ng-template #connectError>
	<div class="p-4">
		<button
			type="button"
			class="btn close-x rounded-circle position-absolute top-0 right-0 end-0 mt-3 me-3"
			(click)="closeTemplateModal()"
		></button>
		<p class="pt-3">
			<span class="text-big text-blue">{{ "auction.live.mqttError" | translate }}</span>
		</p>
	</div>
</ng-template>